export const ROUTES = {
  HOME: '/',
  CONTRIBUTION_FIRST_PAGE: '/contribution-first-page',
  OTP_AUTHENTICATION_PAGE: '/otp-authentication',
  CONTRIBUTION_HISTORY_PAGE: '/contribution-history',
  FORM_10_BE_LISTING: '/form10be-listing',
  ABOUT_BSG: '/AboutUs',
  CONTACT_US: '/ContactUs',
  TERMS_OF_USE: '/TermsOfUse',
  DELIVERY_AND_SHIPMENT: '/DeliveryAndShipment',
  TERM_CONDITION: '/Termcondition',
  CHANGE_PASSWORD: '/ChangePassword',
};
